import { getSystemInfo } from '@/api/site'
import { getLocalStorage, setLocalStorage } from '@/utils/cache'
const state = () => ({
  systemInfo: getLocalStorage('systemInfo') ? JSON.parse(getLocalStorage('systemInfo')) : {
    systemName: '',
    description: ''
  }
})

const mutations = {
  SET_SYSTEMINFO: (state, systemInfo) => {
    state.systemInfo = systemInfo
    setLocalStorage('systemInfo', JSON.stringify(systemInfo))
  }
}

const actions = {
  // 获取用户信息
  getSystemInfo({ commit, state }) {
    let systemInfo = {
      systemName: '',
      description: ''
    }
    return new Promise((resolve, reject) => {
      getSystemInfo({}).then(response => {
        const { data } = response
        systemInfo = Object.assign({}, systemInfo, data)
        // console.log('systemInfo', systemInfo)
        commit('SET_SYSTEMINFO', systemInfo)
        resolve(data)
      }).catch((err) => {
        // console.log('systemInfo-err', err)
        resolve()
      })
    })
  }
}
const getters = {
  systemInfo: state => state.systemInfo
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}


// WEBPACK FOOTER //
// ./src/store/module/site.js